import {Pipe, PipeTransform} from '@angular/core';

import {Formatter} from '@selpia/shared/utils';
import {Measure} from '@selpia/shared/models';

@Pipe({
  standalone: true,
  name: 'formatByMeasure',
})
export class FormatByMeasurePipe implements PipeTransform {
  transform(value: number | undefined | null, measure: Measure | undefined, short = false): string {
    return Formatter.formatByMeasure(value, measure, short);
  }
}
